import * as actionTypes from "../constants/actionTypes";
import * as actions from "../actions";
import { Observable } from "rxjs";
import { normalize, schema } from "normalizr";

const fetchTypes = () => (action, store) =>
  Observable.ajax({
    crossDomain: true,
    responseType: "json",
    headers: {
      "Content-Type": "application/json"
    },
    url: `http://case.dev.interconnessioni.it/api/item/types`
  });

const fetchMarkets = () => (action, store) =>
  Observable.ajax({
    crossDomain: true,
    responseType: "json",
    headers: {
      "Content-Type": "application/json"
    },
    url: `http://case.dev.interconnessioni.it/api/item/markets`
  });

export const getMainFiltersEpic = (action$, store) =>
  action$.ofType(actionTypes.GET_MAIN_FILTERS).mergeMap(action => {
    // uso forkJoin per chiamare più servizi in sequenza
    return Observable.forkJoin(
      fetchTypes()(action, store),
      fetchMarkets()(action, store)
    )
      .map(results => {
        // forkJoin ritorna un array con i risultati delle chiamate precedenti
        const [typologies, markets] = results;
        const _typologies = normalizeTypologies(typologies.response);
        const _markets = normalizeMarkets(markets.response);
        // console.log("markets ", _markets);
        return actions.getMainFiltersSuccess(_typologies, _markets);
      })
      .catch(error =>
        Observable.of(actions.getMainFiltersError(error.message))
      );
  });

export const filtersByTypologiesChangeEpic = (action$, store) =>
  action$
    .ofType(
      actionTypes.GET_MAIN_FILTERS
      // actionTypes.SET_TYPOLOGY,
      // actionTypes.TOGGLE_TYPOLOGY_ON_SELECTED_LIST,
      // actionTypes.TOGGLE_MARKET_ON_SELECTED_LIST,
      // actionTypes.SET_MARKET
    )
    .switchMap(action => {
      return Observable.of(actions.getFiltersByTypology());
    });

/*
  SERVICES FOR getFiltersByTypologiesEpic
*/

const fetchCategories = () => (action, store) => {
  /*
      categorie
      Parameters:
      types
      market
  
      depth - default 0 (the whole branch)
    */
  const state = store.getState();
  const { filters } = state;
  const typeID = filters.mainFilters.typologies.selectedTypologies;
  const market = filters.mainFilters.markets.selectedMarkets;
  // console.log("typeID ", typeID);
  // console.log("market ", market);
  return Observable.ajax({
    crossDomain: true,
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    url: `http://case.dev.interconnessioni.it/api/item/categories`,
    body: {
      types: typeID,
      market: market
    }
  });
};

const fetchTags = () => (action, store) => {
  /*
      tags
      Parameters:
      types
      market
  
      depth - default 0 (the whole branch)
    */

  const state = store.getState();
  const { filters } = state;
  const typeID = filters.mainFilters.typologies.selectedTypologies;
  const market = filters.mainFilters.markets.selectedMarkets;
  return Observable.ajax({
    crossDomain: true,
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    url: `http://case.dev.interconnessioni.it/api/item/tags`,
    body: {
      types: typeID,
      market: market
    }
  });
};

const fetchProperties = () => (action, store) => {
  /*
      tags
      Parameters:
      types
      market
  
      depth - default 0 (the whole branch)
    */

  const state = store.getState();
  const { filters } = state;
  const typeID = filters.mainFilters.typologies.selectedTypologies;
  const market = filters.mainFilters.markets.selectedMarkets;
  return Observable.ajax({
    crossDomain: true,
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    url: `http://case.dev.interconnessioni.it/api/item/properties`,
    body: {
      types: typeID,
      market: market
    }
  });
};

export const getFiltersByTypologiesEpic = (action$, store) =>
  action$.ofType(actionTypes.GET_FILTERS_BY_TYPOLOGY).mergeMap(action => {
    return Observable.forkJoin(
      fetchCategories()(action, store),
      fetchTags()(action, store),
      fetchProperties()(action, store)
    )
      .map(results => {
        // forkJoin ritorna un array con i risultati delle chiamate precedenti
        const [categories, tags, properties] = results;
        const _categories = normalizeCategories(categories.response);
        const _tags = normalizeTags(tags.response);
        const _properties = normalizeProperties(properties.response);
        // console.log("_categories ", _categories);

        return actions.getFiltersByTypologySuccess(
          _categories,
          _tags,
          _properties
        );
      })
      .catch(error =>
        Observable.of(actions.getFiltersByTypologyError(error.message))
      );
  });

const normalizeTypologies = response => {
  const typology = new schema.Entity("typologies", {});
  const mySchema = [typology];

  const normalizedData = normalize(response.item_type, mySchema);
  const { result, entities } = normalizedData;
  return {
    all: result,
    byId: entities.typologies
  };
};

const normalizeMarkets = response => {
  const typology = new schema.Entity("markets", {});
  const mySchema = [typology];

  const normalizedData = normalize(response.market, mySchema);
  const { result, entities } = normalizedData;
  return {
    all: result,
    byId: entities.markets
  };
};

const normalizeCategories = response => {
  const category = new schema.Entity(
    "categories",
    {},
    {
      idAttribute: "key"
    }
  );
  const mySchema = [category];

  // const normalizedData = normalize(treeData, mySchema);
  const normalizedData = normalize(response, mySchema);
  const { result, entities } = normalizedData;
  const { categories } = entities;
  return {
    all: result,
    byId: categories
  };
};

const normalizeProperties = response => {
  const property = new schema.Entity(
    "properties",
    {},
    {
      idAttribute: "key"
    }
  );
  const mySchema = [property];

  // const normalizedData = normalize(treeData, mySchema);
  const normalizedData = normalize(response, mySchema);
  const { result, entities } = normalizedData;
  const { properties } = entities;
  return {
    all: result,
    byId: properties
  };
};

const normalizeTags = response => {
  const tag = new schema.Entity("tags", {});
  const mySchema = [tag];

  const normalizedData = normalize(response, mySchema);
  const { result, entities } = normalizedData;
  return {
    all: result,
    byId: entities.tags
  };
};



// WEBPACK FOOTER //
// ./src/epics/filters.js